import { render, staticRenderFns } from "./TwoButtonDialog.vue?vue&type=template&id=618df931&scoped=true"
import script from "./TwoButtonDialog.vue?vue&type=script&lang=js"
export * from "./TwoButtonDialog.vue?vue&type=script&lang=js"
import style0 from "./TwoButtonDialog.vue?vue&type=style&index=0&id=618df931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618df931",
  null
  
)

export default component.exports